<a class="d-flex flex-row"
   [tabIndex]="-1"
   [routerLink]="[searchLink]"
   [queryParams]="removeQueryParams | async"
   (click)="searchFilterService.minimizeAll()">
  <label class="mb-0 d-flex w-100">
    <input type="checkbox" [checked]="true" class="my-1 align-self-stretch filter-checkbox" role="checkbox" tabindex="0"/>
    <span class="filter-value ps-1 break-facet">
        @if (resolvedLabel$ | async; as resolvedLabel) {
          {{ 'search.filters.' + filterConfig.name + '.' + resolvedLabel | translate: {default: resolvedLabel} }}
        } @else {
          {{ 'search.filters.' + filterConfig.name + '.' + selectedValue.value | translate: {default: selectedValue.label} }}
        }
    </span>
  </label>
</a>
